import { createRef } from '@funtech-int/rival';

export interface RumManager {
    setPage(this: void, page: string): void;
    logEventFloat(
        this: void,
        name: string,
        value: number,
        additional?: Record<string, unknown>
    ): void;
    toString(): string;
}

export const rumManagerRef = createRef<RumManager>('rumManager');
